export { OtherWaysToPay } from "./OtherWaysToPay"
